import type { ReactNode } from "react";
import { X } from "lucide-react";
import { Modal } from "../../ui/Modal";

export function ApiKeyConfirm({
  title,
  body,
  confirmLabel,
  busy,
  onConfirm,
  onClose,
}: {
  title: string;
  body: ReactNode;
  confirmLabel: string;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal>
      <div
        className="fixed inset-0 z-dialog flex items-center justify-center bg-black/40 p-4"
        onClick={() => {
          if (!busy) onClose();
        }}
      >
        <div
          className="flex w-full max-w-md flex-col rounded-lg bg-surface text-fg shadow-2xl"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="flex items-center justify-between border-b border-line px-3 py-2">
            <h2 className="text-sm font-semibold">{title}</h2>
            <button
              type="button"
              onClick={onClose}
              disabled={busy}
              className="rounded p-1 hover:bg-hover disabled:opacity-50"
              aria-label="Close"
            >
              <X size={16} />
            </button>
          </div>
          <div className="flex flex-col gap-3 p-4 text-[12px]">
            <div className="text-muted">{body}</div>
            <div className="flex items-center gap-3">
              <button
                type="button"
                disabled={busy}
                onClick={onConfirm}
                className="rounded bg-red-500 px-3 py-1.5 font-medium text-white hover:bg-red-600 disabled:opacity-50"
              >
                {confirmLabel}
              </button>
              <button
                type="button"
                className="text-[11px] text-muted hover:text-fg disabled:opacity-50"
                disabled={busy}
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
